import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["value", "children", "visible", "tipFormatter"],
      _excluded2 = ["tipFormatter", "tipProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import 'rc-tooltip/assets/bootstrap.css';
import Slider from 'rc-slider';
import raf from 'rc-util/lib/raf';
import Tooltip from 'rc-tooltip'; // Source:
// https://github.com/react-component/slider/blob/master/docs/examples/components/TooltipSlider.tsx

import { jsx as _jsx } from "react/jsx-runtime";

const HandleTooltip = props => {
  const {
    value,
    children,
    visible,
    tipFormatter = val => `${val}`
  } = props,
        restProps = _objectWithoutProperties(props, _excluded);

  const tooltipRef = React.useRef();
  const rafRef = React.useRef(null);

  function cancelKeepAlign() {
    // eslint-disable-next-line
    raf.cancel(rafRef.current);
  }

  function keepAlign() {
    rafRef.current = raf(() => {
      var _tooltipRef$current;

      (_tooltipRef$current = tooltipRef.current) === null || _tooltipRef$current === void 0 ? void 0 : _tooltipRef$current.forceAlign();
    });
  }

  React.useEffect(() => {
    if (visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }

    return cancelKeepAlign;
  }, [value, visible]);
  return /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({
    placement: "top",
    overlay: tipFormatter(value),
    overlayInnerStyle: {
      minHeight: 'auto'
    },
    ref: tooltipRef,
    visible: visible,
    getTooltipContainer: getTooltipContainer
  }, restProps), {}, {
    children: children
  }));
}; // Determine the container of the tooltip
// If the slider is in an embed, then the tooltip should be in the embed root (Shadow DOM)


const getTooltipContainer = triggerNode => {
  const embedRoot = triggerNode.closest('[data-embed="body"]');

  if (embedRoot) {
    return embedRoot;
  }

  return document.body;
};

export const handleRender = (node, props) => {
  return /*#__PURE__*/_jsx(HandleTooltip, {
    value: props.value,
    visible: props.dragging,
    children: node
  });
};

const TooltipSlider = _ref => {
  let {
    tipFormatter,
    tipProps
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded2);

  const tipHandleRender = (node, handleProps) => {
    return /*#__PURE__*/_jsx(HandleTooltip, _objectSpread(_objectSpread({
      value: handleProps.value,
      visible: handleProps.dragging,
      tipFormatter: tipFormatter
    }, tipProps), {}, {
      children: node
    }));
  };

  return /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, props), {}, {
    handleRender: tipHandleRender
  }));
};

export default TooltipSlider;